import React from 'react';
import Home from '../Components/Home/Home';
import Main from '../Components/Main/Main';

const HomePage = () => (
  <main>
    <Home />
    <Main />
  </main>
);

export default HomePage;
